import { RegionsDomain } from 'core/typing/domains/RegionsDomain/RegionsDomain';
import { createEvent } from 'effector';

export const loadRegions = createEvent('loadRegions');
export const loadRegionsDone = createEvent<RegionsDomain>('loadRegionsDone');
export const loadRegionsFail = createEvent('loadRegionsFail');
